import React, {useState, useEffect} from "react";
import "../../components/cards/Cards.css";
import {Button} from "react-bootstrap";
import {useLocation, useNavigate} from "react-router-dom";
import {apiRequest} from "../../services";
import {toast} from "react-toastify";
import "./Claims.css";
import {ThreeCircles, ThreeDots} from "react-loader-spinner";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

const getUserLanguage = () => {
    const lang = navigator.language || navigator.userLanguage;
    return lang.startsWith("fr") ? "fr" : "en";
};

const MAX_FILE_SIZE = 5 * 1024 * 1024;

function ClaimsDeclaration() {
    const location = useLocation();
    const insured = location.state
    const dispatch = useDispatch();
    const {t, i18n} = useTranslation();
    const currentLanguage = i18n.language;
    const [selectedClaim, setSelectedClaim] = useState(null);
    const [assured, setAssured] = useState(null);
    const [verified, setVerified] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [claimDocs, setClaimDocs] = useState([]);
    const [documentRequirement, setDocumentRequirement] = useState([]);
    const [uploadStatus, setUploadStatus] = useState({});
    const userData = useSelector((state) => state.users);
    const [idSelectAccount, setIdSelectAccount] = useState("");
    const [allDocumentsUploaded, setAllDocumentsUploaded] = useState(false);
    const [documentFiles, setDocumentFiles] = useState({}); // Store files for each document
    const [Major, setMajor] = useState(null);

    const userLanguage = getUserLanguage();

    const UploadDocument = async (docId, file) => {
        if (!file) {
            toast.error(t("PleaseSelectAFile"));
            return;
        }

        if (file.size > MAX_FILE_SIZE) {
            toast.error(t("FileSizeExceeds5MB"));
            return;
        }

        const allowedTypes = [
            "image/jpeg",
            "image/png",
            "image/gif",
            "image/webp",
            "image/svg+xml",
            "text/plain",
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];

        if (!allowedTypes.includes(file.type)) {
            toast.error(t("OnlyImageAndTextFilesAllowed"));
            return;
        }

        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("file", file);
            const url = `/api/techcare/v2/insurance/addClientDeclarationDocument/${1}/${selectedClaim.claimCode
            }/${docId}/${idSelectAccount}`;
            const response = await apiRequest(
                "AC",
                url,
                "POST",
                formData,
                null,
                dispatch,
                navigate
            );

            console.log("response is ", response);
            if (response && response.status === 200) {
                toast.success(t("DocumentUploadedSuccessfully"));
                setUploadStatus((prevStatus) => ({
                    ...prevStatus,
                    [docId]: true,
                }));
                // Clear the file input for this document
                setDocumentFiles((prevFiles) => ({
                    ...prevFiles,
                    [docId]: null,
                }));
            } else if (response && response.status === 409) {
                console.log("=====> ....>", response.body.errors);
                toast.error(response.body.errors);
            } else {
                toast.error(t("FailedDocumentTryAgain"));
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error(t("FailedDocumentTryAgain"));
        }
        setLoading(false);
    };

    console.log("insuranceId", insured);

    useEffect(() => {
        const allUploaded =
            documentRequirement.length > 0 &&
            documentRequirement.every((doc) => uploadStatus[doc.id]);
        setAllDocumentsUploaded(allUploaded);
    }, [documentRequirement, uploadStatus]);

    const fetchAllClaims = async (currentToken) => {
        try {
            const requestData = {
                serviceReference: "GET_ALL_CLAIMS",
                requestBody: "",
            };

            const response = await apiRequest(
                "GATEWAY",
                "",
                "POST",
                requestData,
                userData.token,
                dispatch,
                navigate
            );

            if (response && response.status === 200) {
                setClaimDocs(response.body.data);
            } else {
                toast.error(
                    response.body.meta.message || "Failed to find claims!!! Try Again"
                );
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const fetchData = async () => {
        try {
            const requestData = {
                password: "notRegister",
                userNameOrEmail: "notRegister",
            };

            const response = await apiRequest(
                "LOGIN",
                "TechCareAuthentification/login",
                "POST",
                requestData,
                null,
                dispatch,
                navigate
            );

            if (response && response.status === 200) {
                const newToken = userData.token;
                fetchAllClaims(newToken);
            }
        } catch (error) {
            console.error("Error during login request:", error);
        }
    };

    useEffect(() => {
        fetchAllClaims(userData.token);
    }, [userData.token]);


    const handleClaimChange = (e) => {
        const claimId = e.target.value;
        const selectedClaimObject = claimDocs.find((claim) => claim.id === claimId);
        if (selectedClaimObject) {
            setSelectedClaim(selectedClaimObject);
        } else {
            setSelectedClaim(null);
            setDocumentRequirement([]);
            setUploadStatus({});
            setDocumentFiles({});
        }
    };

    const handleAccountChange = (e) => {
        setIdSelectAccount(e.target.value);
    };

    const fetchAssuredClient = async () => {
        try {
            setLoading(true);
            const requestData = {
                serviceReference: "GET_ASSURED_CLIENT",
                requestBody: idSelectAccount,
            };

            const response = await apiRequest(
                "GATEWAY",
                "",
                "POST",
                requestData,
                userData.token,
                dispatch,
                navigate
            );

            if (response && response.status === 200) {
                setAssured(response.body.data);
                const majorState = isMajor(response.body.data?.beneficiaryOld);
                setMajor(majorState);
                setVerified(true);
                console.log("assure", response.body.data)
            } else {
                toast.error("Error occurred");
            }
        } catch (error) {
            toast.error(error.message || "Error verifying account");
        }
        setLoading(false);
    };
    const isMajor = (old) => {
        if (old >= 18)
            return true
        else
            return false
    }

    useEffect(() => {
        const fetchDocumentByClaimId = async () => {
            if (!selectedClaim) {
                setDocumentRequirement([]);
                setUploadStatus({});
                return;
            }

            setLoading(true);
            try {
                const requestData = {
                    serviceReference: "GET_DOCUMENT_BY_CLAIMS_CODE",
                    requestBody: selectedClaim.claimCode,
                };

                const response = await apiRequest(
                    "GATEWAY",
                    "",
                    "POST",
                    requestData,
                    userData.token,
                    dispatch,
                    navigate
                );
                console.log("====>   response", response);


                if (response && response.status === 200) {
                    let filteredDoc = [];
                    if (Major === true) {
                        console.log("............................>", filteredDoc)
                        const excludedIds = ["BIRTH_CERTIFICATE_COPY", "CERTIFIED_COPY_SURVIVING_PARENT_NATIONAL_IDENTITY"];
                        filteredDoc = response.body.data.filter(doc => !excludedIds.includes(doc.id));
                        console.log("............................>", filteredDoc)
                        setDocumentRequirement(filteredDoc || []);
                    } else if (Major === false) {
                        const excludedIds = ["CNI", "CERTIFIED_COPY_CNI"];
                        filteredDoc = response.body.data.filter(doc => !excludedIds.includes(doc.id));
                        console.log("............................>", filteredDoc)
                        setDocumentRequirement(filteredDoc || []);
                    }
                    setUploadStatus({});
                    console.log("major", Major);
                    console.log("documentRequired", filteredDoc);
                } else {
                    setDocumentRequirement([]);
                    toast.error(
                        response?.body?.meta?.message ||
                        "Failed to fetch required documents."
                    );
                }
            } catch (error) {
                console.error("Error:", error);
                setDocumentRequirement([]);
                toast.error("Error fetching required documents.");
            }
            setLoading(false);
        };

        fetchDocumentByClaimId();
    }, [selectedClaim]);

    const handleFileChange = (docId, e) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > MAX_FILE_SIZE) {
                toast.error(t("FileSizeExceeds5MB"));
                e.target.value = null;
            } else {
                setDocumentFiles((prevFiles) => ({
                    ...prevFiles,
                    [docId]: file,
                }));
            }
        } else {
            setDocumentFiles((prevFiles) => ({
                ...prevFiles,
                [docId]: null,
            }));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitted(true);
        if (allDocumentsUploaded) {
            toast.success(t("ClaimSubmittedSuccessfully"));
        } else {
            toast.error(t("PleaseEnsureAllRequiredFieldsAreFilled"));
        }
    };


    const renderContent = () => {
        return (
            <form onSubmit={handleSubmit} encType="multipart/form-data">
                {assured && (
                    <div className="mb-3">
                        <div className="mb-3">
                            <h5
                                htmlFor="claim-select"
                                className="form-label small-screen-text"
                            >
                                {t("SelectyourClaim")}(*)
                            </h5>
                            <select
                                id="claim-select"
                                value={selectedClaim ? selectedClaim.id : ""}
                                onChange={handleClaimChange}
                                className="form-select p-2 small-screen-input"
                                required
                            >
                                <option value="" disabled className="small-screen-text">
                                    {t("SelectClaim")}
                                </option>
                                {Array.isArray(claimDocs) && claimDocs.length > 0 ? (
                                    claimDocs.map((option) => (
                                        <option
                                            key={option.id}
                                            value={option.id}
                                            className="small-screen-text"
                                        >
                                            {currentLanguage === "fr"
                                                ? option.descriptionFr
                                                : option.descriptionEn}
                                        </option>
                                    ))
                                ) : (
                                    <option value="" className="small-screen-text">
                                        {t("NoClaimavailable")}
                                    </option>
                                )}
                            </select>
                        </div>

                        <div className="mb-3">
                            <div className="mb-3 mt-4">
                                <h5 className="small-screen-text">{t("DOCUMENTSREQUIRED")}</h5>
                                {loading ? (
                                    <div>
                                        <ThreeDots width="24" height="24" color="dark"/>
                                    </div>
                                ) : (
                                    <ul>
                                        {documentRequirement.length > 0 ? (
                                            documentRequirement.map((claimDoc) => (
                                                <li
                                                    key={claimDoc.id}
                                                    style={{
                                                        fontStyle: "italic",
                                                        fontFamily: "Light Italic",
                                                        fontSize: "16px",
                                                    }}
                                                >
                                                    {currentLanguage === "fr"
                                                        ? claimDoc.documentDescriptionFr
                                                        : claimDoc.documentDescriptionEn}
                                                    {uploadStatus[claimDoc.id] ? (
                                                        <span
                                                            style={{color: "green", marginLeft: "10px"}}
                                                        >
                              ✔
                            </span>
                                                    ) : (
                                                        <span style={{color: "red", marginLeft: "10px"}}>
                              ✖
                            </span>
                                                    )}
                                                </li>
                                            ))
                                        ) : (
                                            <li className="small-screen-text">
                                                {t("NoDocumentavailable")}
                                            </li>
                                        )}
                                    </ul>
                                )}
                            </div>
                        </div>

                        {documentRequirement.length > 0 && (
                            <div className="mb-3">
                                <p className="text-warning small-screen-text">
                                    (*{t("uploadEachDocumentIndividually")})
                                </p>
                                <div className="file-upload-info mb-2">
                                    <p className="text-muted small-screen-text">
                                        {t(
                                            "fileUploadGuidance",
                                            "Acceptable file types: PDF, JPG, PNG. Maximum file size: 5MB per file."
                                        )}
                                    </p>
                                </div>
                                {documentRequirement.map((doc) => (

                                    <div key={doc.id} className="mb-3">
                                        <label className="form-label small-screen-text">
                                            {currentLanguage === "fr"
                                                ? doc.documentDescriptionFr
                                                : doc.documentDescriptionEn}
                                        </label>
                                        <input
                                            type="file"
                                            className="form-control form-control-sm"
                                            id={`file-${doc.id}`}
                                            onChange={(e) => handleFileChange(doc.id, e)}
                                            disabled={uploadStatus[doc.id] || loading}
                                        />
                                        <Button
                                            className="button btn-sm mt-2"
                                            type="button"
                                            onClick={() =>
                                                UploadDocument(doc.id, documentFiles[doc.id])
                                            }
                                            disabled={
                                                !documentFiles[doc.id] ||
                                                uploadStatus[doc.id] ||
                                                loading
                                            }
                                        >
                                            {loading ? (
                                                <div
                                                    className="d-flex justify-content-center align-items-center spinner-container">
                                                    <ThreeCircles height="20" width="20"/>
                                                </div>
                                            ) : (
                                                <span className="small-screen-text">
                          {t("UploadDoc")}
                        </span>
                                            )}
                                        </Button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}
            </form>
        );
    };

    return (
        <div>
            <div className="beneficiary">
                <div className="overlay-text">{t("declareClaims")}</div>
            </div>

            <div className="cards p-4" style={{marginBottom: "2rem"}}>
                <div className="d-flex justify-content-between">
                    <div className="d-flex">
                        <h2>{t("claimsDeclaration")}</h2>
                    </div>
                    <Button
                        className="profiles-action-button mb-3"
                        onClick={() => navigate(-1)}
                    >
                        {t("Back")}
                    </Button>
                </div>

                <div className="card p-4">
                    {assured === null && verified === false ? (
                        <div className="card-body">
                            <form>
                                <div className="mb-3">
                                    <h5 className="form-label small-screen-text">
                                        {t("selectYouAccount")}(*)
                                    </h5>
                                    <input
                                        type="text"
                                        className="form-control p-2 small-screen-input"
                                        placeholder={t("selectYouAccount")}
                                        value={idSelectAccount}
                                        onChange={handleAccountChange}
                                        disabled={loading}
                                        required
                                    />
                                    <Button
                                        onClick={fetchAssuredClient}
                                        style={{marginTop: "3rem"}}
                                        className="profiles-action-button"
                                        disabled={!idSelectAccount || loading}
                                    >
                                        {loading ? t("Vérification...") : t("Envoyer")}
                                    </Button>
                                </div>
                            </form>
                        </div>
                    ) : assured ? (
                        allDocumentsUploaded ? (
                            <div className="thankyou">
                                <img src="./images/icon-thank-you.svg" alt=""/>
                                <h2>{t("thankYouHeading")}</h2>
                                <p>{t("thankYouMessage")}</p>
                            </div>
                        ) : (
                            <div className="card-body">{renderContent()}</div>
                        )
                    ) : (
                        <div className="card-body">
                            <p>{t("pleaseSubscribe")}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ClaimsDeclaration;
